export default __webpack_public_path__ + "img/google.952443d7.svg";